export default function SvgMenu5() {
    return (
      <>
    <svg
    xmlns="http://www.w3.org/2000/svg"
    x="0"
    y="0"
    width="10px"
    cursor="pointer"
    fill="#00cc00"
    enableBackground="new 0 0 330 330"
    version="1.1"
    viewBox="0 0 330 330"
    xmlSpace="preserve"
    >
    <path d="M325.606 229.393l-150.004-150a14.997 14.997 0 00-21.213.001l-149.996 150c-5.858 5.858-5.858 15.355 0 21.213 5.857 5.857 15.355 5.858 21.213 0l139.39-139.393 139.397 139.393A14.953 14.953 0 00315 255a14.95 14.95 0 0010.607-4.394c5.857-5.858 5.857-15.355-.001-21.213z"></path>
    </svg>
</>
);
}
